// Centralised content for the marketing site.
// Replace with real firm details when available.

export const FIRM = {
  name: "Nitta Ravi Kishore & Co.",
  short: "NRK & Co.",
  tagline: "Providing Tax, Audit & Advisory Services Since 1998",
  established: 1998,
  yearsExperience: "28+",
  founder: {
    name: "CA. Nitta Ravi Kishore",
    credentials: "B.Com.,  FCA.,  ACMA.,  DISA (ICAI)",
    membership: "",
    image: "/founder.png",
    bio: [
      "CA. Nitta Ravi Kishore is a practicing Chartered Accountant with over 28 years of professional experience in taxation, audit and advisory services.",
      "He has been actively engaged in advising clients on matters relating to tax compliance, regulatory frameworks and financial reporting. His practice covers Direct Taxation, Goods & Services Tax, Statutory and Tax Audits, Corporate Compliance and Advisory engagements.",
      "He is a Fellow Member of the Institute of Chartered Accountants of India, an Associate Member of the Institute of Cost and Management Accountants of India, and holds a Diploma in Information Systems Audit (DISA) from the ICAI.",
      "He is also a regular speaker at professional forums and industry seminars, and contributes to knowledge sharing through his educational initiatives, including his YouTube channel \u201CCA. NRK\u201D.",
    ],
    quote: "Quality, integrity and timely delivery are the cornerstones of every professional engagement we undertake.",
  },
  contact: {
    address1: "11-41-2, Kandulavari Street, 1 Town, Tarapet,",
    address2: "Vijayawada, Andhra Pradesh 520001, India",
    phone: "+91 94400 92595",
    email: "nittakishore@yahoo.com",
    whatsapp: "+919440092595",
    youtube: "https://www.youtube.com/@canrk",
    youtubeEmbedId: "wAVy7AjU4no",
    mapShareUrl: "https://maps.app.goo.gl/gbULRm9L2QkZU5Mh8",
    mapEmbed: "https://www.google.com/maps?q=11-41-2%2C%20Kandulavari%20Street%2C%201%20Town%2C%20Tarapet%2C%20Vijayawada%2C%20Andhra%20Pradesh%20520001&output=embed",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Insights", to: "/insights" },
  { label: "Resources", to: "/resources" },
  { label: "Knowledge Hub", to: "/media" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "tax-consultancy",
    title: "Tax Consultancy and Advisory",
    summary:
      "Strategic and considered advice on direct and indirect tax matters, transactions, restructuring and cross-border arrangements — supported by clear opinions and structured documentation.",
    points: [
      "Direct and indirect tax structuring and opinions",
      "Transaction and restructuring advisory",
      "International taxation and DTAA matters",
      "Representation before tax authorities",
    ],
    icon: "Scale",
  },
  {
    slug: "tax-compliance",
    title: "Tax Compliance and Return Filing",
    summary:
      "End-to-end compliance support for individuals, professionals, firms and corporate entities.",
    points: [
      "Income-tax returns for individuals, firms, companies and NRIs",
      "TDS / TCS computations, returns and reconciliations",
      "GST registrations, periodic returns and refunds",
      "Statutory filings under the Companies Act and LLP Act",
    ],
    icon: "FileCheck2",
  },
  {
    slug: "audits",
    title: "Audit and Assurance Services",
    summary:
      "Independent statutory and tax audit engagements conducted in accordance with applicable Standards on Auditing — strengthening governance and stakeholder confidence.",
    points: [
      "Statutory audit under the Companies Act, 2013",
      "Tax audit under Section 44AB of the Income-tax Act",
      "GST audits and limited reviews",
      "Internal audit and management audit assignments",
    ],
    icon: "ShieldCheck",
  },
  {
    slug: "tax-advisory",
    title: "Regulatory and Compliance Services",
    summary:
      "Long-view advisory on tax planning, succession, residency and capital flows for proprietors, partners, professionals and Non-Resident Indians.",
    points: [
      "Tax planning for individuals, HNIs and business owners",
      "NRI residency, repatriation and Schedule FA disclosures",
      "Capital gains, succession and estate advisory",
      "MSME compliance, including Section 43B(h) impact analysis",
    ],
    icon: "Compass",
  },
];

export const INDUSTRIES = [
  {
    slug: "msme",
    title: "Micro, Small and Medium Enterprises (MSMEs)",
    description:
      "Compliance, governance and growth-stage tax planning for India\u2019s MSME sector — including impact assessments under Section 43B(h) of the Income-tax Act.",
    image: "https://images.pexels.com/photos/95916/pexels-photo-95916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    slug: "traders-manufacturers",
    title: "Traders and Manufacturers",
    description:
      "GST optimisation, turnover-based audit advisory, input-tax-credit reconciliation and supply-chain tax structuring for trading and manufacturing enterprises.",
    image: "https://images.pexels.com/photos/210607/pexels-photo-210607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    slug: "llp",
    title: "Limited Liability Partnerships (LLPs)",
    description:
      "Formation, conversion, partner remuneration structuring and end-to-end LLP compliance under the Income-tax Act, 1961 and the LLP Act, 2008.",
    image: "https://images.pexels.com/photos/6863250/pexels-photo-6863250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    slug: "nri",
    title: "Non-Resident Indians (NRIs)",
    description:
      "Residency planning, Schedule FA disclosures, NRO/NRE structuring, repatriation, capital gains on Indian assets and DTAA-relief advisory for NRIs.",
    image: "https://images.pexels.com/photos/259027/pexels-photo-259027.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    slug: "professionals-individuals",
    title: "Professionals and Individuals",
    description:
      "Practice-aware advisory for doctors, consultants, salaried executives and high-net-worth individuals — covering taxation, succession and statutory disclosures.",
    image: "https://images.pexels.com/photos/164527/pexels-photo-164527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
];

export const RESOURCES = [
  {
    section: "Income Tax",
    items: [
      { label: "Income-tax Act, 1961", href: "https://www.incometaxindia.gov.in/income-tax-act" },
      { label: "Income-tax Rules, 1962", href: "https://www.incometaxindia.gov.in/income-tax-rules" },
      { label: "Circulars", href: "https://www.incometaxindia.gov.in/circulars" },
      { label: "Notifications", href: "https://www.incometaxindia.gov.in/notifications" },
      { label: "Press Releases", href: "https://www.incometaxindia.gov.in/press-release" },
      { label: "e-Filing Portal", href: "https://www.incometax.gov.in/iec/foportal/" },
    ],
  },
  {
    section: "Goods and Services Tax",
    items: [
      { label: "GST Portal", href: "https://www.gst.gov.in/" },
      { label: "Central Acts", href: "https://taxinformation.cbic.gov.in/content-page/explore-act" },
      { label: "GST Rules", href: "https://taxinformation.cbic.gov.in/content-page/explore-rules" },
      { label: "Circulars", href: "https://taxinformation.cbic.gov.in/content-page/explore-circulars" },
      { label: "Notifications", href: "https://taxinformation.cbic.gov.in/content-page/explore-notification" },
      { label: "Advisories and Updates", href: "https://services.gst.gov.in/services/advisory/advisoryandreleases" },
    ],
  },
  {
    section: "Institute of Chartered Accountants of India",
    items: [
      { label: "ICAI Portal", href: "https://www.icai.org/" },
      { label: "Notifications", href: "https://www.icai.org/category/notifications" },
      { label: "Resources", href: "https://www.icai.org/resources.shtml" },
      { label: "Announcements", href: "https://www.icai.org/category/announcements" },
    ],
  },
  {
    section: "Ministry of Corporate Affairs",
    items: [
      { label: "MCA Portal", href: "https://www.mca.gov.in/" },
      { label: "LLP Filings", href: "https://www.mca.gov.in/content/mca/global/en/mca/master-data/MDS.html" },
      { label: "Companies Act, 2013", href: "https://www.mca.gov.in/content/mca/global/en/acts-rules/ebooks/acts.html?act=NTk2MQ==" },
    ],
  },
];

export const SEMINARS = [
  { title: "Speaker for CPE Seminars of ICAI Branches" },
  { title: "Speaker for CPE Seminars of CMA Chapters" },
  { title: "Speaker for CPE Seminars of ICSI Chapters" },
  { title: "Speaker for programs organised by Industry Associations" },
  { title: "Speaker for programs organised by Trade Bodies" },
  { title: "Youtuber – English Channel", handle: "@canrk", href: "https://www.youtube.com/@canrk" },
  { title: "Youtuber – Telugu Channel", handle: "@CANRK.Telugu", href: "https://www.youtube.com/@CANRK.Telugu" },
];

export const VALUES = [
  { title: "Integrity", body: "We adhere to the highest standards of professional ethics and confidentiality in every engagement we undertake." },
  { title: "Quality", body: "Our work is governed by applicable Standards on Auditing and the Code of Ethics issued by the ICAI, ensuring consistency and reliability." },
  { title: "Diligence", body: "Each assignment is approached with technical rigour, careful documentation and a commitment to timely delivery." },
  { title: "Confidentiality", body: "Sensitive client matters are handled with the discretion expected of a long-standing professional practice." },
];
